import { UserInfo } from '@nxtpeople/nxt-styles';
import * as Sentry from '@sentry/vue';
import { computed, watch } from 'vue';
import { useStore } from 'vuex';

export function useApp() {
   const { state, dispatch } = useStore();
   const userInfo = computed(() => state.userInfo?.userInfo);

   watch(userInfo, handleUserChange, { immediate: true });

   function handleUserChange(userInfo?: UserInfo) {
      setSentryUser(userInfo);
      fetchGlobalData(userInfo);
   }

   function setSentryUser(userInfo?: UserInfo) {
      if (!userInfo) return Sentry.setUser(null);
      Sentry.setUser({ username: `${userInfo.first_name} ${userInfo.last_name}`, email: userInfo.email, id: userInfo.id.toString() });
   }

   //#region Global Data
   async function fetchGlobalData(userInfo?: UserInfo) {
      if (!userInfo) return;
      dispatch('setModuleTypes');
      dispatch('setNotificationTypes');
      dispatch('setLanguages');
      dispatch('getPageTypes');
      dispatch('getJourneyStates');
      dispatch('maintenanceStore/getSystemNotification');
   }
   //#endregion

   const loadingUserInfo = computed(() => state.userInfo?.loadingUserInfo);

   return { loadingUserInfo };
}
